import styled from 'styled-components';
import { tokens } from '@welbe/web-design-system';

interface ContainerProps {
	highlight?: boolean;
}

interface LabelProps {
	highlight?: boolean;
	fontSize?: string;
	fontWeight?: number;
	center?: boolean;
}

export const Wrapper = styled.div`
	display: flex;
	width: 100%;
	cursor: pointer;

	:hover {
		background-color: ${tokens.color_gray_light};
		opacity: 0.8;
	}
`;

export const Container = styled.div<ContainerProps>`
	display: grid;
	grid-template-columns: 0.2fr 1.5fr 2fr 0.4fr 0.2fr;
	align-items: center;
	gap: 12px;
	padding: 9px 18px;
	background-color: ${({ highlight }) => highlight && tokens.color_gray_light};
	border-radius: 6px;
	width: 100%;
	padding: 16px 18px;

	div {
		display: grid;
		grid-template-columns: 12fr 1fr;
		align-items: center;

		label {
			width: 42px;
		}
	}
`;

export const Label = styled.label<LabelProps>`
	display: flex;
	align-items: center;
	justify-content: ${({ center }) => center && 'center'};
	margin: 0;
	width: 100%;
	font-size: ${({ fontSize }) => fontSize || '16px'};
	font-weight: ${({ highlight, fontWeight = 600 }) =>
		highlight ? 700 : fontWeight};
	color: ${({ highlight }) =>
		highlight ? tokens.color_black : tokens.color_gray_dark};
	cursor: pointer;
`;

export const Triangle = styled.div`
	width: 0;
	height: 0;
	border-top: 32px solid transparent;
	border-bottom: 32px solid transparent;
	border-left: 32px solid ${tokens.color_gray_light};
`;

export const Square = styled.div`
	width: 32px;
	height: 64px;
`;
